import React, { useContext, useCallback, useEffect } from "react";
import { Input, Button, Form } from "antd";
import { FiltersContext } from "@CONTEXTS";

const Filters = () => {
  const { dispatch, filters } = useContext(FiltersContext);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: "SET_FILTERS",
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { search } = values;
    const obj = {
      search,
    };
    setFilters(obj);
  };

  useEffect(() => {
    resetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const resetFilters = () => {
    dispatch({
      type: "SET_FILTERS",
      payload: { search: null },
    });
  };

  return (
    <Form layout="inline" onFinish={(values) => onFinish(values)}>
      <Form.Item label={null} name="search" style={{ width: 300 }}>
        <Input
          placeholder="Kod veya malzeme adına göre ara…"
          allowClear
          onChange={(e) => {
            // value yoksa (çarpı butonuna tıklanmışsa) otomatik tekrar arasın
            if (e.target.value === "") {
              resetFilters();
            }
          }}
        />
      </Form.Item>

      <Form.Item style={{ width: 135 }}>
        <Button type="primary" block htmlType="submit">
          Ara
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Filters;
